export interface CalendarEvent {
  title: string;
  start: Date;
  end: Date;
  resource: {
    id: number;
    color: string;
  };
}

export interface DateRange {
  start: Date | null;
  end: Date | null;
}

export const DateRangeDefault: DateRange = {
  start: null,
  end: null,
};
